import { getUserInfo } from 'app/selectors';

import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { PageLayout } from '../Layouts/PageLayout';

import { ProjectCreateForm } from './ProjectCreateForm';

export const ProjectCreate = () => {
    const userInfo = useSelector(getUserInfo) as { company: string };

    const defaultValues = useMemo(
        () => ({
            name: '',
            methodology: undefined,
            stage: undefined,
            status: undefined,
            subsidiary: userInfo?.company,
        }),
        [userInfo],
    );

    const breadCrumbsItems = useMemo(
        () => [
            {
                label: 'Реестр проектов',
                href: '/projects',
            },
        ],
        [],
    );

    return (
        <PageLayout title="Создание проекта" breadCrumbsItems={breadCrumbsItems} isLoading={false}>
            <ProjectCreateForm defaultValues={defaultValues} />
        </PageLayout>
    );
};

ProjectCreate.displayName = 'ProjectCreate';
